// Where a campaign is in its life, from the dates the server sends
// (start_at, end_at, grace_ends_at, donations_open_at, minutes_close_at,
// state). Every state message on the teacher and admin dashboards reads
// from this, so "Live now" never shows before launch and the logging
// window is described the same way everywhere. See BUSINESS_RULES §6.
//
//   getting_ready   draft, before donations open
//   donations_open  donations open, reading hasn't started
//   reading         between the start and end dates
//   catch_up        reading ended; minutes can still be logged until the
//                   campaign's logging close (by default 9 AM next morning)
//   wrapping_up     minutes closed; donations stay open until grace ends
//   finished        locked

export function campaignPhase(campaign, now = new Date()) {
  const t = now.getTime();
  const at = (iso) => (iso ? new Date(iso).getTime() : null);

  if (campaign.state === "locked") return "finished";
  if (campaign.state === "draft") {
    const opens = at(campaign.donations_open_at);
    return opens !== null && t >= opens ? "donations_open" : "getting_ready";
  }
  // The server flips states on schedule, so trust it: active is reading
  // (unless an admin launched before the start date).
  if (campaign.state === "active") return t < at(campaign.start_at) ? "donations_open" : "reading";
  const minutesClose = at(campaign.minutes_close_at);
  if (minutesClose !== null && t < minutesClose) return "catch_up";
  return "wrapping_up";
}

// Reading minutes can be logged (mirrors Campaign#accepting_minutes?).
export function phaseAcceptsMinutes(phase) {
  return phase === "reading" || phase === "catch_up";
}

// Whole days from now until the date, never negative ("in 3 days").
export function daysUntil(iso, now = new Date()) {
  if (!iso) return 0;
  return Math.max(0, Math.ceil((new Date(iso).getTime() - now.getTime()) / 86_400_000));
}

// "Mon, Oct 5" from a timestamp, in the viewer's timezone, or `timeZone`
// (the TV display passes the school's: a TV's clock is often left on UTC).
export function formatPhaseDate(iso, { timeZone } = {}) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("en-CA", { weekday: "short", month: "short", day: "numeric", timeZone });
}

// "9:00 a.m. on Sat, Oct 31"
export function formatPhaseTime(iso, { timeZone } = {}) {
  if (!iso) return "";
  const date = new Date(iso);
  const time = date.toLocaleTimeString("en-CA", { hour: "numeric", minute: "2-digit", timeZone });
  return `${time} on ${formatPhaseDate(iso, { timeZone })}`;
}
